import React from 'react';
import ReactModal from 'react-modal';
import { createRoot } from 'react-dom/client';
import { MEDIA_QUERIES } from '../../../../javascripts/constants';
import Mainmenu from '../react/Mainmenu';
import { getItemsFromScript } from './burger-toggle';

const initMainMenu = () => {
  const mql = window.matchMedia(MEDIA_QUERIES.xxl);
  const $mainnav = document.querySelector('#header-mainnav');

  async function onMediaQueryChange(mq, componentRoot) {
    const $script = document.getElementById('bwHeaderNavigation');

    try {
      if (mq.matches) {
        const items = (await getItemsFromScript($script)) || [];
        componentRoot.render(<Mainmenu items={items} />);
      } else if (componentRoot.isMounted) {
        componentRoot.unmount();
      }
    } catch (e) {
      console.error('Error initializing main menu', e);
    }
  }

  if ($mainnav) {
    const root = createRoot($mainnav);
    mql.addEventListener('change', (e) => onMediaQueryChange(e, root));
    onMediaQueryChange(mql, root);
  }
};
ReactModal.setAppElement(document.getElementById('page'));
initMainMenu();
